"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cross = Cross;
const React = __importStar(require("react"));
function Cross(props) {
    return (React.createElement("span", { dangerouslySetInnerHTML: {
            __html: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M18.47 6.59C18.7627 6.29729 18.7627 5.82271 18.47 5.53C18.1773 5.23729 17.7027 5.23729 17.41 5.53L12 10.94L6.59 5.53C6.29729 5.23729 5.82271 5.23729 5.53 5.53C5.23729 5.82271 5.23729 6.29729 5.53 6.59L10.94 12L5.53 17.41C5.23729 17.7027 5.23729 18.1773 5.53 18.47C5.82271 18.7627 6.29729 18.7627 6.59 18.47L12 13.06L17.41 18.47C17.7027 18.7627 18.1773 18.7627 18.47 18.47C18.7627 18.1773 18.7627 17.7027 18.47 17.41L13.06 12L18.47 6.59Z" fill="#36354C"/>
</svg>    
    `,
        } }));
}
//# sourceMappingURL=images.js.map